module.exports = __webpack_public_path__ + "img/hospital.e4d714a2.png";